import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <section className='footer'>
        <span>Developed by Israel Abaho | 2022     
        </span>
    </section>
  )
}

export default Footer